export const months = new Map([
	[1, "Ян"],
	[2, "Фе"],
	[3, "Ма"],
	[4, "Ап"],
	[5, "Ма"],
	[6, "Ию"],
	[7, "Ию"],
	[8, "Ав"],
	[9, "Се"],
	[10, "Ок"],
	[11, "Но"],
	[12, "Де"],
]);
